"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeBackofficehelp_de_de = void 0;
function backofficeBackofficehelp_de_de() {
    return {
        "backofficehelp.title": "Hilfsseite",
        "backofficehelp.headerbutton": "Hilfe"
    };
}
exports.backofficeBackofficehelp_de_de = backofficeBackofficehelp_de_de;
